module.exports = __webpack_public_path__ + "img/airballoon.4d5a0c44.png";